import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-744dcaa8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  width: "200",
  height: "200",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("polygon", {
  points: "100,20 190,180 10,180",
  fill: "none",
  stroke: "white"
}, null, -1));
const _hoisted_3 = ["fill"];
const _hoisted_4 = ["fill"];
const _hoisted_5 = ["fill"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [_hoisted_2, _createElementVNode("polygon", {
    points: "10,180 100,120 190,180",
    fill: $data.color[$props.colors.charAt(0)]
  }, null, 8, _hoisted_3), _createElementVNode("polygon", {
    points: "10,180 100,120 100,20",
    fill: $data.color[$props.colors.charAt(1)]
  }, null, 8, _hoisted_4), _createElementVNode("polygon", {
    points: "100,20 190,180 100,120",
    fill: $data.color[$props.colors.charAt(2)]
  }, null, 8, _hoisted_5)]);
}